// var customJS = function() {
//   console.log('CPB is here');
//   moduleApp.init();
//   $(document).on('click', '.cpb-option-type-text', function(){
//     moduleApp.addThumbDesc();
//   })
// }

// var customJSTwo = function() {
//   if($('.thumb-name.once').length <1) {
//     $('.cpb-option-type-img img').each( function() { 
//       var altText = $(this).attr('alt'); 
//       if(altText.indexOf('{')<0) {
//         $(this).after('<div class="thumb-name once">' + altText + '</div>')
//       } else {
//         try {
//           var altObj = JSON.parse(altText.trim());
//           if(altObj.Label)	{
//             var label = altObj.Label.trim();
//             $(this).after('<div class="thumb-name once">' + label + '</div>');
//           }
//         } catch(e) {             
//         }
//       }
//     }); 
//   };
//   var fabricSelector = ".cpb-category-title:contains('Fabric'), .cpb-category-title:contains('FABRIC')";
//   var catSelector = ".cpb-category";
//   var $root = $('#product-builder');
//   var fabricCount = $(".cpb-category-title:contains('Fabric'), .cpb-category-title:contains('FABRIC')").length;

//   var titles = document.querySelectorAll(".cpb-category-title");
//   var titlesBefore2 = [];
//   // for(var i = 0; i < titles.length; i++) {
//   //   if(titles[i].querySelector('span').innerText.indexOf('2. ') === 0) {
//   //     i = titles.length;
//   //     continue;
//   //   }
//   //   titlesBefore2.push(titles[i]);

//   // }

//   $('.cpb-category').each(function(index) {
//     $(this).attr('data-catcount', index)
//   });

//   // $root.find(fabricSelector)
//   //         .addClass('fabric-category')
//   //         .parents(catSelector).attr('data-collapsed', '0');
//   // //var fabricCats = $(".cpb-category-title:contains('Fabric'), .cpb-category-title:contains('FABRIC')");
//   // //fabricCats.next('.cpb-category-content').css('height', '0px');
//   // $root.on('click', fabricSelector, function(){
//   //     var $this = $(this);
//   //     if($this.parents(catSelector).attr('data-collapsed') == '0'){
//   //     $root.find(fabricSelector).parents(catSelector).attr('data-collapsed', '0');
//   //     $this.parents(catSelector).attr('data-collapsed', '1');

//   //   } else {
//   //     $this.parents(catSelector).attr('data-collapsed', '0');
//   //   };
//   // });

//   $(titlesBefore2).addClass('fabric-category').parents(catSelector).attr('data-collapsed', '0').on('click', function() {
//     var $this = $(this);
//     if($this.attr('data-collapsed') == '0') {
//       $(titlesBefore2).parents(catSelector).attr('data-collapsed', '0');
//       $this.attr('data-collapsed', '1');
//     } else {
//       $this.attr('data-collapsed', '0');
//     };
//   });

//   //fabricCats.click(function() {
//   //  if($(this).next('.cpb-category-content').css('height') == '0px'){
//   //    fabricCats.next('.cpb-category-content').css('height', '0px');
//   //    $(this).next('.cpb-category-content').css('height', 'auto');
//   //
//   //  } else {
//   //    $(this).next('.cpb-category-content').css('height', '0px');
//   //  };
//   //});  
//   //  fabricCats.addClass('fabric-category');

//   if($('.insertonce').length < 1) {
//     $root.find(fabricSelector).first().prepend('<div class="insertonce" style="padding-bottom: 4px;">1. CHOOSE YOUR FABRIC</div>');
//   };

//   moduleApp.addThumbDesc();

//   $('.cpb-next-tab-button').click(function() { var scrollTarget = document.getElementById('shopify-section-header');
//                                               scrollTarget.scrollIntoView(); console.log('tock');});


// };

function customAddToCart() {
    if (!!window._cpb.settings === false) window._cpb.settings = {}
    window._cpb.settings.addToCartOverride = async data => {
        const shippingElem = document.querySelector('.mto_date input[name="properties[Shipping]"]');
        const shippingPropertyString = shippingElem.value
        data.items.forEach(item => {
            const properties = item.properties;
            if (!properties) return
            for (let prop in properties) {
                if (properties[prop] && typeof properties[prop] == 'string' && properties[prop].includes('"Price": ')) {
                    const parsedObj = JSON.parse(properties[prop].split('} ')[0] + '}');
                    delete parsedObj.Price;
                    properties[prop] = JSON.stringify(parsedObj) + properties[prop].split('} ')[1];
                }
            }
            if (properties._image) {
              properties.Shipping = shippingPropertyString;
            }
        })
        console.log(data, 'data')

        fetch("/cart/add.js", {
            "headers": {
                "content-type": "application/json;charset=UTF-8"
            },
            "body": JSON.stringify({
                items: data.items
            }),
            "method": "POST"
        }).then(() => {
            if(data.redirect) location.href = '/cart'
        })
    }
}


var cpbLoaded = function() {
  Konva?.stages[0]?.setPreventDefault(false);

  //     observer fix fix
  let priceEl = $('.cpb-product-price');
  // priceEl.before(priceEl.clone(true).addClass('cpb-product-price-full cpb-product-price-full-clone'));
  // priceEl.hide();
  //     observer fix fix

  observer.observe(priceEl[0], {
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true,
  });

  observerFix(); // forced initial update to count default choices

  moduleApp.init();

  // customJS();
  // customJSTwo(); 
  // $('.cpb-add-to-cart-button').click( function() {
  //   if($('.cpb-product-price').html() == '€0.00') {
  //     alert('Please choose a fabric before adding the product to the cart!'); return false;
  //   }

  // });
  // $('#product-builder').on('click', '.react-tabs__tab, .cpb-next-tab-button', function() {
  //  setTimeout(customJSTwo, 300);
  // }); 
};

$('div.wrapper nav.breadcrumb').after('<div class="builderwarning">The Configurator is not available on mobile devices</div>');

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(e){
  setTimeout(cpbLoaded, 1000);
  customAddToCart();
});


var $window, $document, $body, $root;

var moduleApp = {
  init: function() {
    this.initGlobals();
    this.addThumbDesc();
    // this.calcTax();
    this.activateMoreInfo();
    $('body').on('CPB_ON_OPTIONS_UPDATE', this.activateMoreInfo.bind(this));
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', (event) => {
      this.addThumbDesc();
    })
  },
  initGlobals :function(){
    $window = $(window);
    $document = $(document);
    $body = $('#body');
    $root = $('#product-builder');
  },
  addThumbDesc: function() {
    var $img, $parent;

    $parent = $root.find('.cpb-option-type-img');
    $img = $parent.find('img');
    $img.each(function(idx, el) {
      const desc = el.parentElement.parentElement.querySelector('.cpb-option-label');
      try {
        const obj = JSON.parse(el.getAttribute('alt'));
        // console.log(el.parentElement.parentElement.querySelector('.cpb-option-label'));
        desc.innerHTML = obj.Label;
      } catch(e) {
      }
      desc.style.display = 'block';
    })
  },
  calcTax: function() {
    $('.cpb-product-actions-first').append('<div class="money non-eu-money" id="nonEu"></div>');
    var priceStr = '';
    var price;
    var newPrice;
    var targetNode = document.querySelector('.cpb-product-actions-first .non-eu-money');
    var config = { attributes: true, childList: true, subtree: true };

    var callback = function(mutationsList, observer) {
      for(var mutation of mutationsList) {
        if (mutation.target.className.includes('non-eu-money') && typeof mutation.addedNodes[0] !== "undefined") {
          newPrice = (Number(mutation.addedNodes[0].data.replace('€', '').replace('(Non-EU: ', '').replace(')', '')) * 100);
        }
      }
      $('body').find('.cpb-product-full-price .cpb-product-price-full')
      .addClass('js-dynamic-price')
      .attr('data-non-vat-price', newPrice)
      .removeAttr('data-non-vat-price-calculated');
      initVatPricesManipulation();
    };

    var observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
  },
  activateMoreInfo: function() {
    $('.cpb-category-content .cpb-category-desc').each(function() {
      var $this = $(this);
      $this.hide();
      if($this.text() === '') return;
      var parent = $this.closest('.cpb-category');
      if(parent.find('.cpb-custom-show-info').length) return;
      var icon = $('<a class="cpb-custom-show-info" href="#" aria-label="more info">?</a>').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $.fancybox.open($this);
      });
      parent.find('.cpb-category-title__inner > span').after(icon);      	
    });

  }
}




let oldPrice = '';

function observerFix() {
  const getCookie = (name) => {
    name = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  }
  const vatList = { BE:1.21,BG:1.20,DK:1.25,DE:1.19,EE:1.20,FI:1.24,FR:1.20,GR:1.24,IE:1.23,IT:1.22,HR:1.25,LV:1.21,LT:1.21,LU:1.17,MC:1.20,MT:1.18,NL:1.21,AT:1.20,PL:1.23,PT:1.23,RO:1.19,SE:1.25,SK:1.20,SI:1.22,ES:1.21,CZ:1.21,HU:1.27,CY:1.19 };
  const nonEURO = ['BG', 'HR', 'CZ', 'DK', 'HU', 'PL', 'RO', 'SE']
  
  let priceStr = '', 
      price,
      newPrice,
      currency = '',
      priceNode = false,
      actPrice;

  if (document.querySelector('.cpb-product-price') != null) {
    priceNode = document.querySelector('.cpb-product-price:not(.cpb-product-price-full)');
    actPrice = priceNode.innerText;
  }

  if (!priceNode) throw new Error('No priceNode found!');

  price = actPrice,
  priceStr = priceNode.innerText.match(/[\d\.,]+/)[0];
  currency = actPrice.split(priceStr);
  price = parseFloat(Number(priceStr.replace(',','').replace('.','')) / 100);

  if (actPrice == oldPrice) return;

  if (Object.keys(vatList).indexOf(getCookie("localization")) >= 0) {
    let calculatedPrice = price / 1.22 * vatList[getCookie("localization")]
    if(nonEURO.includes(getCookie("localization"))) calculatedPrice *= 1.05
    newPrice = Math.ceil(calculatedPrice);
  } else {
    newPrice = Math.ceil(price / 1.22 * 1.1);
  }
  oldPrice = newPrice;
  document.querySelector('.cpb-product-price span').innerHTML = `${currency[0]}${Number(newPrice).toLocaleString()}${currency[1]}`;
  console.log(`${currency[0]}${Number(newPrice).toLocaleString()}${currency[1]}`)
}

let observer = new MutationObserver(mutation => {
  try {
    if (mutation[0].target.parentNode.parentNode.classList.contains('cpb-product-price') && !mutation[0].target.parentNode.parentNode.classList.contains('cpb-product-price-full-clone')) {
      observerFix();
    }
  } catch(err) {
    console.log(err);
  }
});